import { isString } from 'lodash';

export const KEY_NEW_UI = 'old-ui';

class ThemeServices {
  isTheOldUI() {
    const data = localStorage.getItem(KEY_NEW_UI);
    return isString(data) ? data === 'true' : false;
  }

  setUI(value) {
    localStorage.setItem(KEY_NEW_UI, JSON.stringify(value));
  }
}

export default new ThemeServices();
